(function () {
  'use strict';

  const BASE_PRICES = {
    'DIN A4':      39.97,
    '30cm X 40cm': 49.97,
    '50cm X 70cm': 79.97,
  };

  const FRAME_ADDONS = {
    'Without Frame':   { 'DIN A4': 0,  '30cm X 40cm': 0,  '50cm X 70cm': 0  },
    'Oak Wood':        { 'DIN A4': 29, '30cm X 40cm': 39, '50cm X 70cm': 69 },
    'Dark Brown Wood': { 'DIN A4': 29, '30cm X 40cm': 39, '50cm X 70cm': 69 },
    'Black Wood':      { 'DIN A4': 29, '30cm X 40cm': 39, '50cm X 70cm': 69 },
    'Black Aluminium': { 'DIN A4': 29, '30cm X 40cm': 39, '50cm X 70cm': 69 },
    'White Aluminium': { 'DIN A4': 29, '30cm X 40cm': 39, '50cm X 70cm': 69 },
  };

  function formatPrice(amount) {
    return '€' + amount.toFixed(2);
  }

  function getSelectByIndex(index) {
    var selects = document.querySelectorAll('select[id*="main-"]');
    return selects[index] || null;
  }

  function getSelectedSize() {
    var sel = getSelectByIndex(0);
    return sel ? sel.value : null;
  }

  function getFrameSelect() {
    return getSelectByIndex(2);
  }

  function updateFrameOptions() {
    var select = getFrameSelect();
    if (!select) return;

    var selectedSize = getSelectedSize();

    Array.from(select.options).forEach(function (option) {
      var baseName = option.getAttribute('data-base-name') || option.textContent.trim();
      option.setAttribute('data-base-name', baseName);

      var frameKey = Object.keys(FRAME_ADDONS).find(function (k) {
        return baseName.toLowerCase() === k.toLowerCase();
      });

      if (!frameKey || frameKey === 'Without Frame') {
        option.textContent = baseName;
        return;
      }

      if (!selectedSize || FRAME_ADDONS[frameKey][selectedSize] === undefined) {
        option.textContent = baseName + '   (+€29 – €69)';
      } else {
        var addon = FRAME_ADDONS[frameKey][selectedSize];
        option.textContent = baseName + ' \u00A0\u00A0\u00A0 (+' + formatPrice(addon) + ')';
      }
    });
  }

  function updateMainPrice() {
    var selectedSize = getSelectedSize();
    var frameSelect = getFrameSelect();
    if (!frameSelect) return;

    var selectedFrame = frameSelect.value;
    if (!selectedSize || !selectedFrame) return;

    var base = BASE_PRICES[selectedSize];
    var addons = FRAME_ADDONS[selectedFrame];
    if (base === undefined || !addons) return;
    var addon = addons[selectedSize];
    if (addon === undefined) return;

    var total = base + addon;
    var priceSelectors = [
      '.price__regular .price-item--regular',
      '.price .price-item--regular',
      '.price-item--regular',
      '[data-product-price]',
      '.product__price .price-item',
    ];
    for (var i = 0; i < priceSelectors.length; i++) {
      var el = document.querySelector(priceSelectors[i]);
      if (el) { el.textContent = formatPrice(total); break; }
    }
  }

  function runUpdates() {
    updateFrameOptions();
    updateMainPrice();
  }

  function init() {
    var hasForm = document.querySelector(
      'form[id^="product-form-"], form[action*="/cart/add"], variant-selects'
    );
    if (!hasForm) return;

    runUpdates();
    setTimeout(runUpdates, 100);
    setTimeout(runUpdates, 300);
    setTimeout(runUpdates, 600);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT') {
        runUpdates();
        setTimeout(runUpdates, 100);
        setTimeout(runUpdates, 300);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();